import '../../App.css'
import { useState, useEffect } from 'react';
import { Table, Pagination } from 'antd';
import { useSelector } from 'react-redux';
import axios from 'axios';
import moment from "moment";
import { format } from 'date-fns';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Appconfig from '../../config/config';
import AccountSidebar from '../../components/AccountSidebar';

function AccountStatement() {
    const userInfo = useSelector((state) => state?.userInfo?.userdata);

    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [data, setData] = useState([]);
    
    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = data && data.slice(startIndex, endIndex);

    const [formData, setFormData] = useState({
        "user_id": userInfo && userInfo?._id,
        "type": "0",
        "from_date": moment().subtract(1, 'days').format('YYYY-MM-DD'),
        "to_date": moment().format('YYYY-MM-DD'),
        "game_type": "All",
    });

    const [showFromCalendar, setShowFromCalendar] = useState(false);
    const [showToCalendar, setShowToCalendar] = useState(false);

    const handleFromDate = (newDate) => {
        setFormData({ ...formData, from_date: moment(newDate).format('YYYY-MM-DD') });
        setShowFromCalendar(false);
    };

    const handleToDate = (newDate) => {
        setFormData({ ...formData, to_date: moment(newDate).format('YYYY-MM-DD') });
        setShowToCalendar(false);
    };

    const formattedFromDate = formData.from_date;
    const formattedToDate = formData.to_date;

    const filterAccountStatement = async () => {
        const payload = {
            ...formData,
            from_date: moment(formData.from_date).format('YYYY-MM-DD'),
            to_date: moment(formData.to_date).format('YYYY-MM-DD')
        };

        try {
            const response = await axios.post(`${Appconfig.apiUrl}reports/aurafilteraccountStatement`, payload, {
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.data.resultData) {
                setData(response.data.resultData);
            } else {
                setData([]);
            }
        } catch (error) {
            console.error("Error fetching statement:", error);
        }
    };

    useEffect(() => {
        filterAccountStatement();
    }, []);

    const onChangeDataType = (datatype) => {
        let newFromDate = moment();
        if (datatype === "BACKUP") newFromDate = moment().subtract(3, 'month');
        if (datatype === "OLD") newFromDate = moment().subtract(1, 'year');
        
        setFormData({
            ...formData,
            from_date: newFromDate.format('YYYY-MM-DD')
        });
    };

    const columns = [
        {
            title: 'Date/Time',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 150,
            render: (text) => <span className="text-gray-800 text-[11px] font-semibold">{moment(text).format('YYYY-MM-DD HH:mm:ss')}</span>,
        },
        {
            title: 'Deposit',
            dataIndex: 'amount',
            key: 'deposit',
            render: (_, record) => (
                record.banking_type === "Deposit" 
                ? <span className="text-[#508d0e] font-bold text-[11px]">{Number(record.amount).toFixed(2)}</span> 
                : <span className="text-center block">-</span>
            ),
        },
        {
            title: 'Withdraw',
            dataIndex: 'amount',
            key: 'withdraw',
            render: (_, record) => (
                record.banking_type === "Withdraw" 
                ? <span className="text-[#d50000] font-bold text-[11px]">{Number(record.amount).toFixed(2)}</span> 
                : <span className="text-center block">-</span>
            ),
        },
        {
            title: 'Balance',
            dataIndex: 'balance',
            key: 'balance',
            render: (text) => <span className="text-gray-800 font-bold text-[11px]">{Number(text).toFixed(2)}</span>,
        },
        {
            title: 'Remark',
            dataIndex: 'remarks',
            key: 'remarks',
            render: (text) => <span className="text-gray-600 text-[11px] line-clamp-1">{text}</span>,
        },
        {
            title: 'From/To',
            key: 'fromTo',
            render: (_, record) => (
                <span className="text-gray-800 text-[11px] flex items-center gap-1 whitespace-nowrap">
                    {record.from || 'Master'} 
                    <span>→</span> 
                    {record.to || 'User'}
                </span>
            ),
        },
    ];

    return (
        /* pt-[70px] and pb-[80px] ensure the content is visible 
           between your fixed header and footer on mobile.
        */
        <div className="bg-[#eeeeee] min-h-screen font-sans text-sm pt-[70px] pb-[90px] lg:pt-0 lg:pb-4 px-2 md:px-4">
            <div className="max-w-[1300px] mx-auto flex flex-col lg:flex-row gap-4 items-start">
                
                <AccountSidebar />

                <div className="flex-1 w-full overflow-hidden">
                    <h2 className="text-sm font-bold mb-2 mt-2 text-gray-800 uppercase">Account Statement</h2>

                    {/* Filter Section - Responsive Grid */}
                    <div className="bg-[#e0e6e6] border border-gray-300 rounded p-3 mb-4 grid grid-cols-2 md:flex md:flex-wrap gap-2 items-center">
                        <select onChange={(e) => onChangeDataType(e.target.value)} className="h-9 border border-gray-400 rounded px-2 text-xs text-gray-700 bg-white col-span-2 md:col-span-1">
                            <option value="LIVE">LIVE DATA</option>
                            <option value="BACKUP">BACKUP DATA</option>
                            <option value="OLD">OLD DATA</option>
                        </select>

                        <div className="relative">
                            <input 
                                type="text" 
                                value={formattedFromDate} 
                                onClick={() => {setShowFromCalendar(!showFromCalendar); setShowToCalendar(false)}}
                                readOnly 
                                className="h-9 border border-gray-400 rounded px-2 text-xs w-full md:w-32 cursor-pointer bg-white" 
                                placeholder="From Date"
                            />
                            {showFromCalendar && (
                                <div className="absolute top-10 left-0 z-[100] shadow-2xl scale-90 origin-top-left md:scale-100">
                                    <Calendar onChange={handleFromDate} value={new Date(formData.from_date)} />
                                </div>
                            )}
                        </div>

                        <div className="relative">
                            <input 
                                type="text" 
                                value={formattedToDate} 
                                onClick={() => {setShowToCalendar(!showToCalendar); setShowFromCalendar(false)}}
                                readOnly 
                                className="h-9 border border-gray-400 rounded px-2 text-xs w-full md:w-32 cursor-pointer bg-white" 
                                placeholder="To Date"
                            />
                            {showToCalendar && (
                                <div className="absolute top-10 left-0 z-[100] shadow-2xl scale-90 origin-top-left md:scale-100">
                                    <Calendar onChange={handleToDate} value={new Date(formData.to_date)} />
                                </div>
                            )}
                        </div>

                        <button onClick={filterAccountStatement} className="bg-[#333] text-white h-9 px-4 rounded text-xs font-bold hover:bg-black col-span-2 md:col-span-1 transition-colors">
                            Get Statement
                        </button>
                    </div>

                    {/* Table Container with Horizontal Scroll for Mobile */}
                    <div className="bg-white border-t-2 border-t-gray-800 shadow-sm rounded-b">
                        <div className="overflow-x-auto w-full">
                            <Table
                                columns={columns}
                                dataSource={paginatedData}
                                pagination={false}
                                rowKey="_id"
                                size="small"
                                className="custom-statement-table min-w-[700px] lg:min-w-full"
                                components={{
                                    header: {
                                        cell: (props) => (
                                            <th {...props} className="bg-[#e0e0e0] text-[#333] font-bold text-xs border-b border-gray-300 py-3 px-2 text-left" />
                                        ),
                                    },
                                }}
                            />
                        </div>
                        
                        {/* Pagination Footer */}
                        <div className="bg-[#f5f5f5] p-3 flex justify-center items-center gap-2 border-t">
                            <button 
                                onClick={() => setCurrent(c => Math.max(c - 1, 1))}
                                disabled={current === 1}
                                className="px-4 py-1.5 bg-white border border-gray-300 text-xs font-bold text-gray-600 rounded shadow-sm disabled:opacity-50"
                            >
                                Prev
                            </button>
                            
                            <span className="px-4 py-1.5 bg-[#333] text-[#ffb600] text-xs border border-black rounded font-bold shadow-inner">
                                {current}
                            </span>

                            <button 
                                onClick={() => setCurrent(c => (endIndex < data.length ? c + 1 : c))}
                                disabled={endIndex >= data.length}
                                className="px-4 py-1.5 bg-white border border-gray-300 text-xs font-bold text-gray-600 rounded shadow-sm disabled:opacity-50"
                            >
                                Next
                            </button>
                        </div>
                    </div>

                    {/* Mobile helper text */}
                    <p className="lg:hidden text-[10px] text-gray-500 mt-2 text-center italic">
                        * Swipe table horizontally to see all columns
                    </p>
                </div>
            </div>
            
            <style>{`
                .custom-statement-table .ant-table-thead > tr > th {
                    background: #e0e0e0 !important;
                    color: #333 !important;
                    font-size: 11px !important;
                    white-space: nowrap;
                }
                .custom-statement-table .ant-table-tbody > tr > td {
                    padding: 10px 8px !important;
                }
                /* React Calendar Mobile Fix */
                .react-calendar {
                    border-radius: 8px;
                    border: 1px solid #ccc;
                    font-family: sans-serif;
                }
            `}</style>
        </div>
    )
}

export default AccountStatement;